import { Grid, Typography } from "@mui/material";
import { forwardRef } from "react";
import { DetailsBox, SpeechBubblePaper, SpeechBubbleWrapper } from "./styles";

export const SpeechBubble = forwardRef(function SpeechBubble({ id, children, direction, details, ...props }, ref) {
  return (
    <SpeechBubbleWrapper container size={12} justifyContent={direction === "sent" ? "flex-end" : "flex-start"}>
      <Grid ref={ref} size={10}>
        <SpeechBubblePaper id={id} elevation={0} direction={direction} {...props}>
          <Typography variant="body1">{children}</Typography>
        </SpeechBubblePaper>
        <DetailsBox direction={direction}>{details}</DetailsBox>
      </Grid>
    </SpeechBubbleWrapper>
  );
});
